module.exports = __webpack_public_path__ + "static/media/picto-new-message.4824540d.svg";